import { setClass } from '$lib/util/dom';

function handleScroll(e: Event) {
	const target = e?.target as HTMLElement;
	if (!(target instanceof HTMLElement)) return;

	const reachedHorizontalEnd = target.scrollLeft + target.clientWidth + 10 >= target.scrollWidth;

	setClass(target, reachedHorizontalEnd, 'reached-horizontal-end');
}

export default function scrollAction(element: HTMLElement) {
	element.addEventListener('scroll', handleScroll);

	return {
		destroy() {
			element.removeEventListener('scroll', handleScroll);
		}
	};
}
